import { useState, useEffect, useRef, useMemo } from "react";
import { CSSTransition } from 'react-transition-group';
import { createPortal } from "react-dom";

import { BsThreeDotsVertical } from "react-icons/bs";
import { LuGitMerge } from "react-icons/lu";
import { LuWorkflow } from "react-icons/lu"; // has symmetrical flow lines
//import FilterIcon from "../../assets/images/filter.svg";
import { LuInfinity } from "react-icons/lu";



import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { openOverlay, deleteRisk, gotoRiskDashboard, gotoBowtie } from "../../store/actions/riskActions";
import { gotoIncident } from "../../store/actions/incidentActions";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { ColumnsBlock } from "../Report/Editor";




/*
const DefaultColumnFilter = ({ name, column: { filterValue, setFilter, preFilteredRows, id } }) => {

    const [filterOpen, setFilterOpen] = useState(false);
    return (
        <div className="">
            {filterOpen ? (

                <>
                    <div className="flex items-center">
                        <img onClick={() => { setFilterOpen(!filterOpen); setFilter('') }} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 mr-1" />
                        <input
                            value={filterValue || ''}
                            onChange={e => {
                                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                            }}
                            autoFocus
                            placeholder={`Search ${id}`}
                            style={{
                                width: '100%',
                                padding: '4px',
                                borderRadius: '5px',
                                fontWeight: 'normal'
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="flex items-center whitespace-nowrap">
                    <span>{name}</span>
                    <img onClick={() => setFilterOpen(!filterOpen)} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 ml-2" />
                </div>
            )}
        </div>
    );
};
*/
/*
const EditableCell = ({ value, row, column }) => {
    return (

        <div>{value}</div>
    )
}

*/
/*
const CustomHeader2= ({ column }) => {

    const hasFilter = column.hasFilter || false;
    return (
        hasFilter ? <DefaultColumnFilter name={column.title} column={column} /> : <div>{column.title}</div>

    );
};
*/
const DropdownMenu = ({ row, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentPage, pageSize, sortBy } = useSelector((s) => s.risk);
  const { profile } = useSelector((s) => s.profile);
  const { activeDepartmentId } = useSelector((s) => s.department);

  const submit = () => {
  confirmAlert({
    message: "Are you sure you want to delete this risk?",
    buttons: [
      {
        label: "Yes",
        onClick: async () => {
          await dispatch(
            deleteRisk(
              row.original.ID,
              currentPage,
              pageSize,
              sortBy,
              activeDepartmentId,
              null,
              true,
            )
          );

          //getAllRisksFN();
        }
      },
      { label: "No", onClick: () => void 0 }
    ]
  });

  onClose?.();
};

  return (
    <div
      className="w-48 bg-white text-sm rounded-md border border-[#3b3b3b] shadow-lg"
      style={{ pointerEvents: "auto" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="p-2">
        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(openOverlay(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-edit text-xs"></i>
          <span className="ml-2">
            {profile.role === "Auditor" ? t("riskTable.actions.view") : t("riskTable.actions.edit")}
          </span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoRiskDashboard(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-chart-line text-xs"></i>
          <span className="ml-2">{t("riskOverview.tabs.stats")}</span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoBowtie(row.original.ID));
            onClose?.();
          }}
        >
          <LuInfinity className="w-4 h-4" />
          <span className="ml-2">{t("riskTable.actions.bowtie")}</span>
        </div>

        <div
          className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
          onClick={() => {
            dispatch(gotoIncident(row.original.ID));
            onClose?.();
          }}
        >
          <i className="fas fa-exclamation-triangle text-xs"></i>
          <span className="ml-2">{t("riskTable.actions.incident")}</span>
        </div>

        {profile.role !== "Auditor" && (
          <div
            className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black"
            onClick={submit}
          >
            <i className="fas fa-trash text-xs"></i>
            <span className="ml-2">{t("riskTable.actions.delete")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const DropdownLabel = ({ row }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const getViewportPos = () => {
    const r = buttonRef.current?.getBoundingClientRect();
    if (!r) return { top: 0, left: 0 };
    return { top: r.bottom + 4, left: r.left }; // no gap!
  };
  const [pos, setPos] = useState(getViewportPos());

  const toggle = () => {
    setPos(getViewportPos());
    setIsOpen((v) => !v);
  };

  useEffect(() => {
    if (!isOpen) return;
    const onDown = (e) => {
      const inBtn = buttonRef.current?.contains(e.target);
      const inMenu = menuRef.current?.contains(e.target);
      if (!inBtn && !inMenu) setIsOpen(false);
    };
    document.addEventListener("mousedown", onDown, true);
    return () => document.removeEventListener("mousedown", onDown, true);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const recalc = () => setPos(getViewportPos());
    window.addEventListener("scroll", recalc, true);
    window.addEventListener("resize", recalc);
    return () => {
      window.removeEventListener("scroll", recalc, true);
      window.removeEventListener("resize", recalc);
    };
  }, [isOpen]);

  const portalRoot = useMemo(() => document.body, []);

  return (
    <>
      <div
        ref={buttonRef}
        className="rounded-full cursor-pointer text-[#3b3b3b] dropdown-menu p-2 w-10 h-10 text-center"
        onClick={toggle}
        title={t("riskTable.actions.more")}
      >
        <i className="fas fa-ellipsis-v"></i>
      </div>

      {isOpen &&
        createPortal(
          <div
            className="fixed z-[999999] pointer-events-none"
            style={{ top: pos.top, left: pos.left }}
          >
            <div ref={menuRef} className="pointer-events-auto">
              <DropdownMenu row={row} onClose={() => setIsOpen(false)} />
            </div>
          </div>,
          portalRoot
        )}
    </>
  );
};





const statusBadge = (value, t) => {
  // Check if the value is 'Draft' or 'Approved' to set the font color
  const fontColor = (value === 'Draft' || value === 'Approved') ? 'text-customGreen' : 'text-customYellow';

  const display =
    value === "In Review"
      ? t("riskOverview.statusOptions.inReview")
      : value === "Approved"
        ? t("riskOverview.statusOptions.approved")
        : value;

  return (
    <div className={`badge ${fontColor} items-center overflow-hidden text-ellipsis whitespace-nowrap font-bold p-2`}>
      <span>{display}</span>
    </div>
  )
}

/*
const Badge = ({ value, isPositive, arrowType }) => {
    const backgroundColor = isPositive ? 'bg-customGreen' : 'bg-customRed';
    const arrow = arrowType === 'up' ? ArrowUpGreen : arrowType === 'down' ? ArrowDownRed : arrowType === 'left' ? ArrowUpRed : ArrowDownGreen;

    return (
        <div className={`badge ${backgroundColor} flex items-center justify-center text-center p-2 rounded-[5px] text-white whitespace-nowrap overflow-hidden text-ellipsis`}>
            <span className="">{value.replace('+', '').replace('-', '')}</span>
            <img src={arrow} alt="Arrow" className="w-4 h-4 ml-1" />
        </div>
    )
};
*/

const cellRenderer = ({ value }) => {
  return <div className="p-2">{value}</div>
}

const getBarColor = (value) => {
  if (value >= 75) return '#00AFB9'; // Green for high values
  if (value >= 50) return '#FFD166'; // Yellow for medium values
  if (value > 0) return '#EF476F'; // Red for low values
  return '#f07167'; // Default background color for 0
};


export const createRiskColumns = (t) => [
  {
    Header: t('riskTable.headers.id'),
    accessor: 'ID',
    title: 'ID',
    width: 55,
    minWidth: 50,
    maxWidth: 65,
    Cell: ({ value }) => (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap" title={value ? `R-${value}` : 'N/D'}>
        {value ? `R-${value}` : 'N/D'}
      </div>
    )
  },


  {
    Header: t('riskTable.headers.owner'),
    accessor: 'Owner',
    title: 'Owner',
    width: 150,
    minWidth: 120,
    maxWidth: 180,
    hasFilter: true,
    Cell: ({ value, row }) => {
      const ownerFirstName = row.original.OwnerFirstName; // Access first name from the row data
      const ownerLastName = row.original.OwnerLastName; // Access last name from the row data
      return (
        <div className="overflow-hidden text-ellipsis whitespace-nowrap">
          {ownerFirstName} {ownerLastName}
        </div>
      );
    }
  },
  {
    Header: t('riskTable.headers.title'),
    accessor: 'Title',
    title: 'Title',
    width: 340,
    minWidth: 260,
    maxWidth: 520,
    Cell: ({ value }) => (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap" title={value}>
        {value || 'N/D'}
      </div>
    )
  },
 {
  Header: t('riskTable.headers.category'),
  accessor: 'Framework',
  title: 'Category',
  width: 190,
  minWidth: 150,
  maxWidth: 190,
  hasFilter: true,
  Cell: ({ row }) => {
    const framework = row.original.Framework;

    const map = {
      1: {
        labelKey: 'it',
        bg: 'bg-blue-50',
        text: 'text-blue-700',
        border: 'border-blue-200',
        icon: (
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <rect x="3" y="4" width="18" height="14" rx="2" strokeWidth="2" />
            <path d="M8 20h8" strokeWidth="2" />
          </svg>
        ),
      },
      2: {
        labelKey: 'compliance',
        bg: 'bg-purple-50',
        text: 'text-purple-700',
        border: 'border-purple-200',
        icon: (
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeWidth="2"
              d="M9 12l2 2 4-4M12 3l7 4v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V7l7-4z"
            />
          </svg>
        ),
      },
      0: {
        labelKey: 'operational',
        bg: 'bg-orange-50',
        text: 'text-orange-700',
        border: 'border-orange-200',
        icon: (
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeWidth="2"
              d="M12 9v4m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"
            />
          </svg>
        ),
      },
    };

    const cfg = map[framework];
    if (!cfg) return <span className="text-gray-400">N/D</span>;

    const catLabel = t(`riskTable.category.${cfg.labelKey}`);

    return (
      <div
        className={`
          inline-flex items-center gap-1.5
          px-2.5 py-1
          rounded-full border
          text-xs font-medium
          ${cfg.bg} ${cfg.text} ${cfg.border}
        `}
        title={catLabel}
      >
        {cfg.icon}
        <span className="whitespace-nowrap">{catLabel}</span>
      </div>
    );
  },
},



  {
    Header: t('riskTable.headers.controls'),
    accessor: 'controlsCount',
    title: 'Controls',
    width: 80,
    minWidth: 70,
    maxWidth: 90,
    hasFilter: true,
    Cell: ({ row }) => {
      const controlsCount =
        Array.isArray(row.original.controls) ? row.original.controls.length
          : Array.isArray(row.original.Controls) ? row.original.Controls.length
            : row.original.controlsCount ?? row.original.ControlsCount ?? 0;

      return (
        <div className="overflow-hidden text-ellipsis whitespace-nowrap" title={`${controlsCount}`}>
          {controlsCount}
        </div>
      );
    }
  },



  {
    Header: t('riskTable.headers.controlEfficiency'),
    accessor: 'AverageEfficiencyLevel',
    title: 'Control Efficiency',
    width: 150,
    minWidth: 140,
    maxWidth: 160,
    hasFilter: true,
    Cell: ({ value }) => (
      <div className="relative w-32 h-6 bg-[#999999] rounded-full flex items-center">
        <div
          className="absolute h-full rounded-full"
          style={{
            width: `${value || 0}%`,
            backgroundColor: getBarColor(value), // Call a function to determine the color
          }}
        />
        <span className="relative text-white ml-2 text-xs">
          {value ? `${parseFloat(value).toFixed(0)}%` : t('riskTable.cellNoControl')}
        </span>
      </div>
    )
  },

  {
    Header: t('riskTable.headers.status'),
    accessor: 'Status',
    title: 'Status',
    width: 200,
    minWidth: 180,
    maxWidth: 220,
    hasFilter: true,
    Cell: ({ value, row }) => (
      <div
        className="flex items-center justify-between"
        onClick={e => e.stopPropagation()}
      >
        {/* status badge */}
        <div className="flex-shrink-0">
          {statusBadge(value, t)}
        </div>

        {/* dropdown with adequate spacing */}
        <div className="flex-shrink-0 ml-2">
          <DropdownLabel row={row} />
        </div>
      </div>
    )
  },

  {
    accessor: 'financial',
    title: 'financial',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything


  },
  {
    accessor: 'operational',
    title: 'operational',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'reputational',
    title: 'reputational',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'financial_history',
    title: 'financial_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything


  },
  {
    accessor: 'operational_history',
    title: 'operational_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'reputational_history',
    title: 'reputational_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
];

export const createComplianceColumns = (t) => [
  {
    Header: t('riskTable.headers.id'),
    accessor: 'ID',
    title: 'ID',
    width: 60,
    minWidth: 50,
    maxWidth: 70,
    Cell: cellRenderer
  },
  {
    Header: t('riskTable.headers.owner'),
    accessor: 'Owner',
    title: 'Owner',
    width: 150,
    minWidth: 120,
    maxWidth: 180,
    hasFilter: false,
    Cell: ({ value, row }) => {
      const ownerFirstName = row.original.OwnerFirstName; // Access first name from the row data
      const ownerLastName = row.original.OwnerLastName; // Access last name from the row data
      return (
        <div className="overflow-hidden text-ellipsis whitespace-nowrap">
          {ownerFirstName} {ownerLastName}
        </div>
      );
    }
  },
  {
  Header: t('riskTable.headers.title'),
  accessor: 'Title',
  title: 'Title',
  width: 250,
  minWidth: 180,
  maxWidth: 300,
  Cell: ({ value }) => (
    <div className="overflow-hidden text-ellipsis whitespace-nowrap" title={value}>
      {value || 'N/D'}
    </div>
  )
},

{
  Header: t('riskTable.headers.category'),
  accessor: 'Category',
  title: 'Category',
  width: 150,
  minWidth: 130,
  maxWidth: 170,
  hasFilter: false,
  Cell: () => (
    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium bg-purple-50 text-purple-700 border-purple-200" title={t("riskTable.category.compliance")}>
      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeWidth="2" d="M9 12l2 2 4-4M12 3l7 4v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V7l7-4z" />
      </svg>
      <span className="whitespace-nowrap">{t("riskTable.category.compliance")}</span>
    </div>
  )
},
  {
    Header: 'Compliance Level',
    accessor: 'ComplianceLevel',
    title: 'Compliance Level',
    width: 150,
    minWidth: 140,
    maxWidth: 160,
    hasFilter: true,
    Cell: ({ value }) => (
      <div className="relative w-32 h-6 bg-[#999999] rounded-full flex items-center">
        <div
          className="absolute h-full rounded-full"
          style={{
            width: `${value || 0}%`,
            backgroundColor: getBarColor(value),
          }}
        />
        <span className="relative text-white ml-2 text-xs">
          {value ? `${parseFloat(value).toFixed(0)}%` : t('riskTable.noData')}
        </span>
      </div>
    ),
  },

  {
    Header: t('riskTable.headers.status'),
    accessor: 'Status',
    title: 'Status',
    width: 200,
    minWidth: 180,
    maxWidth: 220,
    hasFilter: true,

    Cell: ({ value, row }) => (
      <div className="flex items-center justify-between" onClick={e => e.stopPropagation()}>
        {/* Render the status badge */}
        <div className="flex-shrink-0">
          {statusBadge(value, t)}
        </div>
        {/* Render the More dropdown icon */}
        <div className="flex-shrink-0 ml-2">
          <DropdownLabel row={row} />
        </div>
      </div>
    )
  },

  {
    accessor: 'financial',
    title: 'financial',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything


  },
  {
    accessor: 'operational',
    title: 'operational',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'reputational',
    title: 'compliance',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'financial_history',
    title: 'financial_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything


  },
  {
    accessor: 'operational_history',
    title: 'operational_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
  {
    accessor: 'reputational_history',
    title: 'reputational_history',
    dontshow: true,
    Cell: ({ value }) => null // Return null to not render anything

  },
];
